module.exports = __webpack_public_path__ + "img/shebei.8d1e4944.png";